const REFRESH_URL = '/token/refresh';

let refreshInFlight: Promise<boolean> | null = null;

/**
 * Asks the API for a new BEARER cookie using the refresh_token cookie. Resolves to whether the
 * session was renewed. Refresh tokens are single-use, so concurrent 401s share one refresh call:
 * a second call would present a refresh token the first one already consumed.
 */
const refreshSession = (headers: HeadersInit): Promise<boolean> => {
  refreshInFlight ??= fetch(`${import.meta.env.VITE_API_BASE_URL}${REFRESH_URL}`, {
    method: 'POST',
    headers,
    credentials: 'include',
  })
    .then((response) => response.ok)
    .catch(() => false)
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
};

export { refreshSession };
